import { Plugin } from "ckeditor5";
import SummarizeResponseCommand from "./summarizeResponseCommand";
import { SUMMARIZE_RESPONSE } from "./summarizeResponseCommand";

export default class SummarizeResponseEditing extends Plugin {
  public init(): void {
    this.editor.commands.add(SUMMARIZE_RESPONSE, new SummarizeResponseCommand(this.editor));
  }

  public static get pluginName(): string {
    return "SummarizeResponseEditing";
  }
}
